import React, {useEffect, useState} from "react";
import {Button, Divider, Stack, Typography} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {useNavigate} from "react-router-dom";
import {dataManager} from "../../../Broadtask";
import StreamCard from "./StreamCard";
import {buttonStyle, cardWrapper, sectionStack} from "../../../../AppStyles";

const StreamManagerPane = (props) => {

    const navigate = useNavigate();

    const [streams, setStreams] = useState(null);

    useEffect(() => {
        reload(false);
    }, []);

    function onRefresh()
    {
        reload(true);
    }

    function reload(force)
    {
        dataManager.getNetworkManager().getInstance(props.networkUID).getStreams(force, (streams) => {
            setStreams(streams);
        });
    }

    function onCreate()
    {
        navigate("../networks/" + props.networkUID + "/streams/create");
    }

    return (
        <Stack direction="column" spacing={1} padding={1} width="100%" alignItems="flex-start" justifyContent="flex-start"
               sx={sectionStack}>
            <Stack direction="row" width="100%"
                   justifyContent="space-between"
                   padding={1} spacing={1}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <img src="/icons/stream.png" width={32} height={32}/>
                    <Typography variant="h6">Data Streams</Typography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <Button onClick={onCreate} sx={buttonStyle} startIcon={<AddCircleOutlineIcon />}>CREATE</Button>
                </Stack>
            </Stack>
            <Divider orientation="horizontal" variant="left" flexItem />
            <Stack direction="row" spacing={1} padding={1} width="100%" minHeight={100}
                   useFlexGap sx={cardWrapper}>
                {
                    streams === null ?
                        <Typography variant="h6">Loading...</Typography>:
                        streams.map(nextStream => {
                            return (<StreamCard key={"stream_" + nextStream.streamUID} networkUID={props.networkUID} entry={nextStream} />)
                        })
                }
            </Stack>
            <Divider orientation="horizontal" variant="left" flexItem />
        </Stack>
);
}

export default StreamManagerPane;
